import { selectBackVisible } from "App/Header/Store/selectors";
import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import logo from "Resources/ALTEKIP_LOGO2020_QUADRI.png";
import logoIsipay from "Resources/ISIPAY_LOGO.png";
import {
  TopAppBar,
  TopAppBarActionItem,
  TopAppBarFixedAdjust,
  TopAppBarRow,
  TopAppBarSection,
  TopAppBarTitle
} from "@rmwc/top-app-bar";
import "@rmwc/top-app-bar/styles";

import "./Header.css";

// #region FONCTION COMPOSANT
/**
 * Composant permettant d'afficher le header
 * @category Header
 */
function Header() {
  // #region INITIALISATION
  // Inialisation des sélecteurs
  const backVisible = useSelector((state) => selectBackVisible(state));

  // Récupération de l'historique
  const history = useHistory();
  // #endregion

  // #region INTERFACE
  return (
    <>
      <TopAppBar
        className="Header-Container"
        fixed
      >
        <TopAppBarRow>
          <TopAppBarTitle className="Header-SectionContainer">
            <img
              alt="logo AltEkip"
              className="Header-Logo"
              src={logo}
            />
            <img
              alt="logo ISIPAY"
              className="Header-Logo"
              src={logoIsipay}
            />
          </TopAppBarTitle>
          {backVisible &&
            <>
              <TopAppBarSection alignStart>
                <TopAppBarActionItem
                  icon="arrow_back_ios_new"
                  onClick={() => history.goBack()}
                />
              </TopAppBarSection>
              <TopAppBarSection alignEnd>
                <div className="Header-EmptyContainer" />
              </TopAppBarSection>
            </>
          }
        </TopAppBarRow>
      </TopAppBar>
      <TopAppBarFixedAdjust />
    </>
  );
  // #endregion
};
// #endregion

export { Header };
